import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyDigitAccepted]',
  standalone: true
})
export class OnlyDigitAcceptedDirective {
  @Input('appOnlyDigitAccepted') allowedPattern: string | RegExp;

  constructor(private el: ElementRef, private control: NgControl) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    event.preventDefault();
    const insertedText = this.el.nativeElement.value;
    let processedText = insertedText.replace(/[^0-9]*/g, '');
    this.control.control.setValue(processedText);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    this.handleTextInsertion(event.clipboardData, event);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    this.handleTextInsertion(event.dataTransfer, event);
  }

  private handleTextInsertion(dataTransfer: DataTransfer | null, event: Event) {

    if (!dataTransfer) {
      return;
    }

    const insertedText = dataTransfer.getData('text/plain');
    if (insertedText === null) {
      return;
    }

    let processedText = insertedText;
    if (this.allowedPattern) {
      const regex = typeof this.allowedPattern === 'string' ? new RegExp(`[^${this.allowedPattern}]`, 'g') : this.allowedPattern;
      processedText = insertedText.replace(regex, '');
    } else {
      processedText = insertedText.replace(/\+1/, '');
      processedText = processedText.replace(/[^0-9]/g, '');
      if (processedText.length > 10) {
        processedText = processedText.substring(0, 10);
      }
    }
    this.control.control.setValue(processedText);
  }
}
